import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ theme: "light", toggle: () => {} });

/**
 * ThemeProvider — controla el tema (light = default, dark = opcional).
 * Aplica EXPLÍCITAMENTE `.light-scope` o `.dark-scope` en <html> para que
 * cualquier elemento descendiente (incluso los que llevan `dark-scope`
 * hardcodeado por compatibilidad) herede los CSS variables del tema activo.
 */
export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    return localStorage.getItem("autoglow_theme") || "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light-scope", "dark-scope");
    root.classList.add(theme === "light" ? "light-scope" : "dark-scope");
    try { localStorage.setItem("autoglow_theme", theme); } catch { /* no-op */ }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return <ThemeCtx.Provider value={{ theme, toggle, setTheme }}>{children}</ThemeCtx.Provider>;
}

export function useTheme() { return useContext(ThemeCtx); }
